import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import { FaEye, FaEdit, FaTrash, FaPlus, FaSearch } from "react-icons/fa";
import axios from "axios";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import dayjs from "dayjs";

import Modal from "../../../components/Modal/Modal";
import ErrorBoundaryRoutes from "../../../components/shared/ErrorBoundaryRoutes";
import { gbState } from "../../../components/shared/GlobalState";
import EventView from "./EventView";
import EventAdd from "../Create/EventAdd";
import placeholderImage from "../../../images/event-placeholder-image.jpg";

const EventListChild = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [addShowModal, setAddShowModal] = useState(false);

  const [currentRecord, setCurrentRecord] = useState({});
  const [data, setData] = useState([]);
  const [{ errorLogApi, user }] = useAtom(gbState);
  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const toggleAddModal = () => {
    // setAddShowModal(!addShowModal);
    navigate("/event/add");
  };

  const getDataFromServer = () => {
    let userToken = localStorage.getItem("token");
    let urlLink = `${process.env.REACT_APP_API_URL}/event/${user.church_id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        const oldData = response.data.events;
        const updatedData = oldData.map((data) => {
          const eventStartDate = dayjs(data?.event_start_date).tz(
            user.time_zone
          );
          const eventEndDate = dayjs(data?.event_end_date).tz(user.time_zone);

          return {
            ...data,
            id: data._id,
            title: data.title,
            description: data.description,
            event_start_date: data?.event_start_date,
            etype: data?.event_type?.label,
            // Convert dates to the user's time zone before formatting
            view_event_start_date: eventStartDate.isValid()
              ? eventStartDate.format("MM-DD-YYYY") +
                " " +
                data?.event_start_time
              : "",
            view_event_end_date: eventEndDate.isValid()
              ? eventEndDate.format("MM-DD-YYYY") + " " + data?.event_end_time
              : "",
          };
        });
        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  const getDataFromServerv1 = () => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/event/${user.church_id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data.users));
        const oldData = response.data.events;
        const updatedData = oldData.map((data) => {
          return {
            ...data,
            id: data._id,
            title: data.title,
            description: data.description,
            event_start_date: data?.event_start_date,
            etype: data?.event_type?.label,
            view_event_start_date: data?.event_start_date
              ? dayjs(data?.event_start_date).format("DD-MM-YYYY") +
                " " +
                data?.event_start_time
              : "",
            event_end_date: data?.event_end_date,
            view_event_end_date: data?.event_end_date
              ? dayjs(data?.event_end_date).format("DD-MM-YYYY") +
                " " +
                data?.event_end_time
              : "",
          };
        });

        setData(updatedData);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  useEffect(() => {
    // const getDataFromServer = () => {
    //   let userToken = localStorage.getItem("token");

    //   let urlLink = `${process.env.REACT_APP_API_URL}/event/${user.church_id}`;

    //   const config = {
    //     method: "GET",
    //     url: urlLink,
    //     headers: {
    //       Authorization: `Bearer ${userToken}`,
    //     },
    //   };
    //   axios(config)
    //     .then(function (response) {
    //       //console.log(JSON.stringify(response.data.users));
    //       const oldData = response.data.events;
    //       const updatedData = oldData.map((data) => {
    //         return {
    //           ...data,
    //           id: data._id,
    //           title: data.title,
    //           description: data.description,
    //           event_start_date: data?.event_start_date,
    //           view_event_start_date: data?.event_start_date
    //             ? dayjs(data?.event_start_date).format("DD-MM-YYYY") +
    //               " " +
    //               data?.event_start_time
    //             : "",
    //           event_end_date: data?.event_end_date,
    //           view_event_end_date: data?.event_end_date
    //             ? dayjs(data?.event_end_date).format("DD-MM-YYYY") +
    //               " " +
    //               data?.event_end_time
    //             : "",
    //         };
    //       });

    //       setData(updatedData);
    //     })
    //     .catch(function (err) {
    //       console.log("error api call ", err);
    //     });
    // };
    getDataFromServer();
  }, [addShowModal]);

  const handleDelete = (row) => {
    confirmAlert({
      title: "",
      message: "Are you sure to delete this User ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecord(row),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecord = (row) => {
    let userToken = localStorage.getItem("token");
    const config = {
      headers: { Authorization: `Bearer ${userToken}` },
    };
    axios
      .delete(`${process.env.REACT_APP_API_URL}/event/delete/${row.id}`, config)
      .then((response) => {
        //alert(JSON.stringify(response));
        getDataFromServer();
      })
      .catch((err) => {
        errorLogApi(err, "EventListChild", "/events");
      });
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [eventTypeFilter, setEventTypeFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const filteredData = useMemo(() => {
    return data.filter((event) => {
      // First filter by search term
      const matchesSearch = Object.values(event).some((value) =>
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );

      // Then filter by event type if not set to "all"
      const matchesEventType =
        eventTypeFilter === "all" ||
        (eventTypeFilter === "public" &&
          event.etype?.toLowerCase().includes("public")) ||
        (eventTypeFilter === "private" &&
          event.etype?.toLowerCase().includes("private"));

      return matchesSearch && matchesEventType;
    });
  }, [data, searchTerm, eventTypeFilter]);

  const paginatedData = useMemo(() => {
    const startIndex = page * rowsPerPage;
    return filteredData.slice(startIndex, startIndex + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  return (
    <div className="w-full px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Event List</h2>
        <Button
          variant="contained"
          color="primary"
          startIcon={<FaPlus />}
          onClick={() => {
            toggleAddModal();
            setCurrentRecord({});
          }}
        >
          Add Event
        </Button>
      </div>

      <div className="mb-4">
        <div className="flex flex-col gap-4 md:flex-row">
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search events..."
            InputProps={{
              startAdornment: <FaSearch className="mr-2 text-gray-400" />,
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <div className="min-w-[200px]">
            <TextField
              select
              fullWidth
              variant="outlined"
              label="Event Type"
              value={eventTypeFilter}
              onChange={(e) => setEventTypeFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Events</option>
              <option value="public">Public Events</option>
              <option value="private">Private Events</option>
            </TextField>
          </div>
        </div>
      </div>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Action</TableCell>
              <TableCell>Image</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Event Type</TableCell>
              <TableCell>Start Date & Time</TableCell>
              <TableCell>End Date & Time</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <div className="flex items-center space-x-1">
                    <Tooltip title="View details">
                      <IconButton
                        size="small"
                        onClick={() => {
                          toggleModal();
                          setCurrentRecord(row);
                        }}
                      >
                        <FaEye className="text-blue-600" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        onClick={() =>
                          navigate("/event/update", { state: row })
                        }
                        // onClick={() => {
                        //   toggleAddModal();
                        //   setCurrentRecord(row);
                        // }}
                      >
                        <FaEdit className="text-gray-600" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(row)}
                      >
                        <FaTrash className="text-red-600" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
                <TableCell>
                  {row.image ? (
                    <img
                      src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/event/${row.image}`}
                      alt="Event"
                      className="object-cover w-12 h-12 rounded-md"
                      crossOrigin="anonymous"
                    />
                  ) : (
                    <img
                      src={placeholderImage}
                      alt="Calendar Event"
                      className="object-cover w-12 h-12 rounded-md"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTUwIiBoZWlnaHQ9IjE1MCIgZmlsbD0iI2YwZjBmMCIvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTQiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIiBmaWxsPSIjNjY2Ij5FdmVudDwvdGV4dD48L3N2Zz4=";
                      }}
                    />
                  )}
                </TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>
                  {row.etype && (
                    <span
                      className={`inline-block px-2 py-1 text-xs font-semibold rounded-full ${
                        row.etype.includes("Public")
                          ? "bg-green-200 text-green-800"
                          : "bg-violet-200 text-violet-800"
                      }`}
                    >
                      {row.etype}
                    </span>
                  )}
                </TableCell>
                <TableCell>{row.view_event_start_date}</TableCell>
                <TableCell>{row.view_event_end_date}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination controls */}
      <div className="flex items-center justify-between mt-4">
        <div>
          <span>Rows per page: </span>
          <select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
          >
            {[5, 10, 25, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div>
          <Button
            disabled={page === 0}
            onClick={() => setPage((prev) => prev - 1)}
          >
            Previous
          </Button>
          <Button
            disabled={paginatedData.length < rowsPerPage}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next
          </Button>
        </div>
      </div>

      {/* Modals */}
      <ErrorBoundaryRoutes route="/events" page="ModalView">
        {showModal && (
          <Modal onClose={toggleModal}>
            <EventView currentRecord={currentRecord} />
          </Modal>
        )}
        {addShowModal && (
          <Modal onClose={toggleAddModal} dialogClassName="modal-90w">
            <h2 className="mb-4 text-xl font-bold">
              {currentRecord?._id ? "Edit" : "Add"} Event
            </h2>
            <hr />
            <EventAdd
              currentRecord={currentRecord}
              setModel={setAddShowModal}
            />
          </Modal>
        )}
      </ErrorBoundaryRoutes>
    </div>
  );
};

export default EventListChild;
